export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

if (!API_BASE_URL) {
	console.warn("API_BASE_URL is not defined in environment variables");
}

// You can also create helper functions for API calls
export const getApiUrl = (endpoint) => {
	if (!API_BASE_URL) {
		throw new Error("API_BASE_URL is not defined in environment variables");
	}
	return `${API_BASE_URL}${
		endpoint.startsWith("/") ? endpoint : `/${endpoint}`
	}`;
};
